<template>
  <v-container fluid class="UserType-mainContainer"> <!-- uso de clases css class="componente-nombreClase"-->
    <v-row v-bind:class="{'smartbell-justifyAlign': userData.onboarding === false}">
      <v-col md="2" class="smartbell-smartbellLeftSideDesktop" v-if="userData.onboarding === true">

      </v-col>
      <v-col md="10" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}" class="UserType-rightAllPlans">
        <v-row justify="center">
          <!-- inicio carta cria-->
          <v-col md="3" class="UserType-singleCard">
            <v-card>
              <v-toolbar dark color="#1460AA">
                  <v-toolbar-title class="UserType-alertTypeTitle"><h4>Cría</h4> <img src="../assets/Cria.svg" alt="" class="UserType-typeImage"></v-toolbar-title>
              </v-toolbar>
              <v-row class="UserType-priceCard">
                <v-col md="12" class="UserType-price">
                  <div v-if="priceType === 'Monthly'">
                      <span class="UserType-priceTextLeft">$549</span><span>MX/Mes</span>
                  </div>
                  <div v-if="priceType === 'Anual'">
                     <span class="UserType-priceTextLeft">$449</span><span>MX/Mes</span>
                  </div>
                </v-col>
                <v-col md="12" class="UserType-description">
                  <ul class="UserType-descriptionDetails">
                    <li>Hasta <strong>50 vacas</strong></li>
                    <li>Alertas via e-mail</li>
                    <li>Soporte técnico en 72hrs</li>
                    <li><strong>1 Usuario</strong></li>
                    <li>Bitácora</li>
                    <li>Hisotrial Peramanente</li>
                  </ul>
                </v-col>
                <v-col md="12" class="UserType-button">
                  <v-btn class="UserType-buttonNormal">Contratar</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- fin carta cria-->

          <!-- inicio carta destete-->
          <v-col md="3" offset-md="1"
          class="std-border-radius std-container-shadow UserType-specialType UserType-singleCard">
            <v-card>
              <v-toolbar dark color="#1460AA">
                  <v-toolbar-title class="UserType-alertTypeTitle"><h3>Destete</h3> <img src="../assets/Destete.svg" alt="" class="UserType-typeImage"></v-toolbar-title>
              </v-toolbar>
              <v-row class="UserType-priceCard">
                <v-col md="12" class="UserType-price">
                  <div class="d-flex flex-column" style="text-align: center;" v-if="priceType === 'Monthly'">
                       <span class="UserType-priceTextLeft">$1,049</span><span>MX/Mes</span>
                  </div>
                  <div v-if="priceType === 'Anual'">
                    <span class="UserType-priceTextLeft">$899</span><span>MX/Mes</span>
                  </div>
                </v-col>
                <v-col md="12" class="UserType-description">
                  <ul class="UserType-descriptionDetails">
                    <li>Hasta <strong>150 vacas</strong></li>
                    <li>Alertas via e-mail y SMS</li>
                    <li>Soporte técnico en 48hrs</li>
                    <li><strong>3 Usuario</strong></li>
                    <li>Bitácora</li>
                    <li>Hisotrial Peramanente</li>
                  </ul>
                </v-col>
                <v-col md="12" class="UserType-button">
                  <v-btn class="UserType-buttonRed">Contratar</v-btn>
                </v-col>
              </v-row>
            </v-card>
            <p>Recomendado</p>
          </v-col>
          <!-- fin carta destete-->

          <!-- inicio carta produccion-->
          <v-col md="3" offset-md="1" class="UserType-singleCard">
            <v-card>
              <v-toolbar dark color="#1460AA">
                  <v-toolbar-title class="UserType-alertTypeTitle"><h4>Producción</h4> <img src="../assets/Produccion.svg" alt="" class="UserType-typeImage"></v-toolbar-title>
              </v-toolbar>
              <v-row class="UserType-priceCard">
                <v-col md="12" class="UserType-price">
                  <div v-if="priceType === 'Monthly'">
                    <span class="UserType-priceTextLeft">$1,549</span><span>MX/Mes</span>
                  </div>
                  <div v-if="priceType === 'Anual'">
                    <span class="UserType-priceTextLeft">$1,299</span><span>MX/Mes</span>
                  </div>
                </v-col>
                <v-col md="12" class="UserType-description">
                  <ul class="UserType-descriptionDetails">
                    <li>Hasta <strong>150 vacas</strong></li>
                    <li>Alertas via 4 canales</li>
                    <li>Soporte técnico 24/7</li>
                    <li><strong>5 Usuario</strong></li>
                    <li>Bitácora</li>
                    <li>Hisotrial Peramanente</li>
                  </ul>
                </v-col>
                <v-col md="12" class="UserType-button">
                  <v-btn class="UserType-buttonNormal">Contratar</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <!-- inicio carta produccion-->
        </v-row>

        <!-- inicio controles inferiores-->
        <v-row justify="center" class="UserType-aditionaButtons">
          <v-col md="3" class="UserType-noPadding">
            <v-col md="12" class="UserType-button UserType-noPadding UserType-priceInfo">
              <p>Precios Membresías + I.V.A</p>
              <P>Mensual  <toggle-button v-model="activeAnualPrices" :sync="true" color="#65D9AC" class="UserType-priceToogleTop"/>Anual</P>
            </v-col>
          </v-col>
          <v-col md="3" offset-md="1" class="UserType-noPadding">
            <v-col md="12" class="UserType-button UserType-noPadding">
              <v-btn class="UserType-aditionalUser smartbell-buttonCorrection">
                <img class="d-flex align-center pr-2"
                     src="../assets/icons/AddUser.png" alt="">
                Usuario adicional<strong class="UserPrice-smallPriceStrong"> $49 </strong><span class="UsertType-smallerPrice">Mx/mes</span>
              </v-btn>
            </v-col>
          </v-col>
          <v-col md="3" offset-md="1" class="UserType-noPadding">
            <v-col md="12" class="UserType-button UserType-noPadding">
              <v-btn class="UserType-aditionalModule smartbell-buttonCorrection" @click="openAditionalModules()">Módulos adicionales</v-btn>
            </v-col>
          </v-col>
        </v-row>
        <!-- fin controles inferiores-->
      </v-col>
    </v-row>
    <v-footer color="#F9FDFE" padless class="smartbell-footer">
        <v-row justify="center" no-gutters>
            <v-col md="10" v-bind:class="{ 'smartbell-offSet2': userData.onboarding}">
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Preguntas frecuentes</v-btn>
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Ayuda</v-btn>
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Precios</v-btn>
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Calcula tu eficiencia</v-btn>
            <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Aviso de privacidad</v-btn>
              <v-btn color="#1460AA" text rounded class="my-2 smartbell-buttonCorrection">Terminos y condiciones</v-btn>
            </v-col>
        </v-row>
    </v-footer>
  </v-container>
</template>

<script>
import NavBar from '@/views/NavBar.vue'
export default {
  name: 'UserType',
    data () {
      return {
        activeNewModules: false,
        priceType:'Monthly',
        activeAnualPrices:false
      }
  },
  components: {
    NavBar
  },
  watch:{
    activeAnualPrices(){
      if(this.activeAnualPrices){
        this.priceType = 'Anual'
      }else{
        this.priceType = 'Monthly'
      }
    }
  },
  computed: {
    userData(){
      return this.$store.getters.getUserData
    },
    animals() {
      return this.$store.getters.getAnimals;
    },
  },
  methods: {
    openAditionalModules(){
      this.$router.push({name:'AditionalModules'})
    }
  },
  mounted () {
  }
};
</script>

<style lang="css">
  @import '../style/UserType.css';
</style>
